import { SET_MODAL_MESSAGE } from "../../actions/action.types";

const modalMessage = (state = "", action: any) => {
  if (action.type === SET_MODAL_MESSAGE) return action.payload;
  else return state;
};

export default modalMessage;
